<section class="pb-4 pb-lg-5 mb-0" *ngIf="relatedproduct?.length > 0">
    <div class="tab-content " id="pills-tabContent">
        <div class="container-fluid px-0 px-lg-2">
            <div class="d-flex justify-content-between align-items-center pb-3 pb-lg-1 mb-0">
                <p class="recently-view-title mb-0 ps-2 ps-lg-4">Related Parts</p>
                <div class="brand-header" *ngIf="relatedproduct?.length > visibleItems">
                    <div class="carousel-controls d-flex gap-2">
                        <button type="button" (click)="prevSlide()">
                            <img [src]="commonImagePath+'previous-img.webp'" alt="Previous" loading="lazy" />
                        </button>
                        <button type="button" (click)="nextSlide()">
                            <img [src]="commonImagePath+'next_img.webp'" alt="Next" loading="lazy" />
                        </button>
                    </div>
                </div>
            </div>
            <div id="best-pan1" class="slider-wrapper" role="tabpanel" aria-labelledby="best-pan1-tab" tabindex="0"  (touchstart)="onTouchStart($event)"
     (touchend)="onTouchEnd($event)">
                <div class="slider-inner"
                    [ngStyle]="{ 'transform': 'translateX(-' + currentIndex * (100 / visibleItems) + '%)' }">
                    <div class="col-6 col-md-4 col-lg-3 w-20 pb-0 pb-md-0 p-1 p-md-2 mt-0 mt-md-4 me-lg-1 slider"
                        *ngFor="let product of relatedproduct">
                        <div class="product-wrap">
                            <div class="product-border position-relative">
                                <div class="blue-print-logo" *ngIf="product?.related_products?.brand?.small_image">
                                    <img [src]="cdnImagePath + product?.related_products?.brand?.small_image"
                                        class="img-fluid" [alt]="product?.related_products?.brand?.name"
                                        loading="lazy" />
                                </div>
                                <ng-container *ngIf="getProductPromotion(product) as promo">
                                    <div class="discount-txt" [ngSwitch]="promo.promotionType">
                                        <ng-container *ngSwitchCase="'percentage_discount'">
                                            {{ promo.promotionDescription }} - {{ promo.promotionDiscount }}% OFF
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'discount_flat_rate'">
                                            {{ promo.promotionDescription }} - ${{ promo.promotionDiscount }} OFF
                                        </ng-container>
                                    </div>
                                </ng-container>
                                <div class="review-img-wrap">
                                    <img [src]="cdnImagePath + product?.related_products?.product_photo?.large_image"
                                        width="180" height="180" [alt]="product?.related_products?.name"
                                        [title]="product?.related_products?.name" (click)="productRedirection(product)"
                                        (error)="onProductImageError($event)" loading="lazy" />
                                </div>
                            </div>
                            <div class="product-title mt-3">
                                <h2 [title]="product?.related_products?.name" class=" product-name mb-0 cursor-pointer"
                                    (click)="productRedirection(product)">
                                    {{ product?.related_products?.name | removeBackslash | stripHtml:60}}
                                </h2>
                                <p class="mt-2 mb-1 short-txt">
                                    {{ product?.related_products?.short_description | truncateHtml:60 }}
                                </p>
                                <!-- <p *ngIf="!hideSubtitle" class="mt-2 mb-1 short-txt"
                                    [innerHTML]="getProductSubtitle(product) | truncateHtml:35">
                                </p> -->
                                <small class="SBFKE-txt">Part#
                                    {{product?.related_products?.product_variations[0]?.sku}}
                                </small>
                            </div>
                            <div class="rating">
                                <ng-container *ngIf="(product.related_products.avgRating | starpipe:'fullStar') > 0">
                                    <ng-container
                                        *ngFor="let full of (product.related_products.avgRating | starpipe:'fullStar':true)">
                                        <i class="fas fa-star star full fullStar fa-sm"></i>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="(product.related_products.avgRating | starpipe:'halfStar') > 0">
                                    <ng-container
                                        *ngFor="let half of (product.related_products.avgRating | starpipe:'halfStar':true)">
                                        <i class="fas fa-star-half-alt half-star fa-sm"></i>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="(product.related_products.avgRating | starpipe:'noStar') > 0">
                                    <ng-container
                                        *ngFor="let no of (product.related_products.avgRating | starpipe:'noStar':true)">
                                        <i class="fas fa-star star empty grey-star fa-sm"></i>
                                    </ng-container>
                                </ng-container>
                                <span class="review-txt">
                                    ({{ product.related_products.reviewsCount }}
                                    {{ product.related_products.reviewsCount > 1 ? 'reviews' : 'review' }})
                                </span>
                            </div>
                            <div class="mt-2 max-h">
                                <ng-container *ngIf="getProductFinalPrice(product)?.finalPrice > 0">
                                    <ng-container *ngIf="product?.related_products?.promotions; else noPromo">
                                        <h6 class="mb-0 price-txt " [ngClass]="product?.related_products?.promotions && chTheme4 ? 'price-red-color' : 'price-regular-color'">
                                            {{ getProductFinalPrice(product).finalPrice || ' ' | customCurrency}}
                                        </h6>
                                        <small class="text-decoration-line-through price-text">
                                            {{ getProductFinalPrice(product).originalPrice || ' ' | customCurrency }}
                                        </small>
                                    </ng-container>
                                    <ng-template #noPromo>
                                        <div class="">
                                            <h6 class="mb-0 price-txt tt">
                                                {{ getProductFinalPrice(product).originalPrice | customCurrency }}
                                            </h6>
                                            <small *ngIf="getProductFinalPrice(product).showMsrp"
                                                class="text-decoration-line-through price-text">
                                                {{ getProductFinalPrice(product).msrpPrice | customCurrency }}
                                            </small>
                                        </div>
                                    </ng-template>
                                </ng-container>
                            </div>
                            <div class="mt-0 stock-info" *ngIf="!inventoryDisabled">
                                <ng-container *ngIf="product?.related_products?.is_special === 'true'">
                                    <a class="stock-txt">Special Order</a>
                                </ng-container>
                                <ng-container *ngIf="product?.related_products?.is_special === 'false'">
                                    <!-- Stock Info Karl -->
                                    <ng-container *ngIf="chTheme1; else nokarl">
                                        <ng-container *ngIf="getInventoryData(product) as inv">
                                            <ng-container
                                                *ngIf="getInventoryMessages(inv.qty, inv.isInStock, inv.warehouse, inv.karlsQty) as inventoryMessages">
                                                <ng-container
                                                    *ngIf="!inventoryMessages.showBackorder; else outOfStockBlock">
                                                    <p class="d-flex flex-column availability-related">
                                                        <!-- Availability -->
                                                        <span class="fw-bold">
                                                            <span class="text-blue">
                                                                {{
                                                                inventoryMessages?.availabilityMsg?.split('
                                                                ').slice(0, 2).join(' ') }}
                                                            </span>
                                                            {{
                                                            inventoryMessages?.availabilityMsg?.split('
                                                            ').slice(2).join(' ') }}
                                                        </span>
                                                        <!-- Urgency -->
                                                        <span class="text-red fw-bold">
                                                            {{ inventoryMessages?.urgencyMsg }}
                                                        </span>
                                                        <!-- Pickup -->
                                                        <span class="fw-bold"
                                                            *ngIf="inventoryMessages?.pickupMsg === 'Local pickup not available'; else pickupAvailable1">
                                                            <span class="local-pickup">Local pickup</span>&nbsp;<span
                                                                class="fw-normal">not
                                                                available</span>
                                                        </span>
                                                        <ng-template #pickupAvailable1>
                                                            <span class="fw-bold"
                                                                [innerHTML]="getPickupMsgHtml(product)"></span>
                                                        </ng-template>
                                                    </p>
                                                </ng-container>
                                                <ng-template #outOfStockBlock>
                                                    <p class="d-flex flex-column availability-related">
                                                        <!-- Availability -->
                                                        <span class="fw-bold">
                                                            {{ inventoryMessages?.availabilityMsg }}
                                                        </span>
                                                        <!-- Pickup -->
                                                        <span class="fw-bold"
                                                            *ngIf="inventoryMessages?.pickupMsg === 'Local pickup not available'; else pickupAvailable1">
                                                            <span class="local-pickup">Local pickup</span>&nbsp;<span
                                                                class="fw-normal">not
                                                                available</span>
                                                        </span>
                                                        <ng-template #pickupAvailable1>
                                                            <span class="fw-bold"
                                                                [innerHTML]="getPickupMsgHtml(product)"></span>
                                                        </ng-template>
                                                    </p>
                                                </ng-template>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                    <!-- Stock Info Other -->
                                    <ng-template #nokarl>
                                        <span class="stock-txt"
                                            [ngClass]="{ 'out-of-stock': +product?.related_products?.product_variations?.[0]?.inventory_qty_on_hand <= 1 }">
                                            <ng-container
                                                *ngIf="+product?.related_products?.product_variations?.[0]?.inventory_qty_on_hand > 0; else outOfStock">
                                                In Stock</ng-container>
                                            <ng-template #outOfStock>Call For Availability
                                                <a [href]="'tel:' + contact" class="text-danger text-decoration-none">
                                                    {{formatted_contact}}
                                                </a>
                                            </ng-template>
                                        </span>
                                    </ng-template>
                                </ng-container>
                            </div>
                            <div class="shipping-wrapper d-flex align-items-start gap-2 red-truck-wrapper">
                                <ng-container *ngIf="product?.related_products?.is_shippable == 0">
                                    <img [src]="commonImagePath+'freeshipping_red_icon.webp'" class="img-fluid"
                                        loading="lazy" />
                                    <span class="shipping-wrap">Free Shipping</span>
                                </ng-container>
                            </div>
                            <div class="d-flex align-items-center gap-1 my-2 color-img-wrapper">
                                <img *ngFor="let color of product?.related_products?.colors.slice(0,3)"
                                    [src]="cdnImagePath + color?.color_chip_img" [alt]="color?.color"
                                    class="img-fluid color-img cursor-pointer" loading="lazy"
                                    (click)="productRedirectionWithColor(product,color)" />
                                <ng-container *ngIf="product?.related_products?.colors?.length > 3">
                                    <div class="black-plus d-flex justify-content-center align-items-center"
                                        (click)="productRedirection(product)">
                                        +
                                    </div>
                                </ng-container>
                            </div>
                            <div class="aff-related-h"
                                *ngIf="product?.related_products?.affirm_eligible || product?.related_products?.paypal_eligible">
                                <ng-container *ngIf="getProductFinalPrice(product)?.finalPrice > 0">
                                    <small class="d-inline-block" *ngIf="product?.related_products?.affirm_eligible">
                                        <app-affirm-widget [amount]="product?.related_products?.promotions
                                    ? getProductFinalPrice(product).finalPrice * 100 
                                    : getProductFinalPrice(product).originalPrice * 100">
                                        </app-affirm-widget>
                                    </small>
                                    <small class="d-inline-block" *ngIf="product?.related_products?.paypal_eligible">
                                        <app-paypal-widget [amount]="product?.related_products?.promotions
                                    ? getProductFinalPrice(product).finalPrice 
                                    : getProductFinalPrice(product).originalPrice" [clientId]="paypalClientId">
                                        </app-paypal-widget>
                                    </small>
                                </ng-container>
                            </div>
                            <!-- Add/Checkout toggle -->
                            <div class="related-btns">
                                <ng-container *ngIf="addToCartFlag[product?.product_key]">
                                    <ng-container
                                        *ngIf="product?.related_products?.product_variations?.length <= 1 && getProductFinalPrice(product)?.finalPrice > 0; else contactusBtn">
                                        <ng-container
                                            *ngIf="addToCartButtons[product.related_products?.product_variations[0]?.product_variation_key]; else checkoutBtn">
                                            <ng-container
                                                *ngIf="+product?.related_products?.product_variations?.[0]?.inventory_qty_on_hand > 0; else outOfStockBtn">
                                                <button class="btn w-100 mt-2 add-cart-btn"
                                                    *ngIf="product?.related_products?.product_variations?.length <= 1 || inventoryDisabled"
                                                    (click)="addToCart(product)">
                                                    ADD TO CART
                                                </button>
                                            </ng-container>
                                            <ng-template #outOfStockBtn>
                                                <button class="btn w-100 mt-2 back-order-btn" (click)="addToCart(product)">
                                                    PLACE BACKORDER
                                                </button>
                                            </ng-template>
                                        </ng-container>
                                        <ng-template #checkoutBtn>
                                            <button [routerLink]="['/cart']" class="btn w-100 mt-2 add-cart-btn" [disabled]="disableCheckoutButton">
                                                CHECKOUT NOW
                                            </button>
                                        </ng-template>
                                    </ng-container>
                                    <ng-template #contactusBtn>
                                        <button *ngIf="product?.related_products?.product_variations?.length <= 1" class="btn w-100 mt-2 back-order-btn"
                                            (click)="onContactClick(product)">
                                            CONTACT US FOR BEST PRICING
                                        </button>
                                    </ng-template>
                                </ng-container>
                                <!-- VIEW PRODUCTS -->
                                <button *ngIf="product?.related_products?.product_variations?.length > 1"
                                    class="btn w-100 mt-2 view-product-btn" (click)="productRedirection(product)">
                                    VIEW PRODUCTS
                                </button>
                            </div>
                            <div class="d-flex gap-2 mt-2 cursor-pointer px-2 wishlist-icon">
                                <!-- <small class="compare-txt">
                                    <img [src]="commonImagePath +'check.webp'" class="img-fluid check-icon"
                                        loading="lazy" />
                                    Compare</small> -->
                                <!-- <img [src]="commonImagePath+'like_img_karls.png'" class="img-fluid heart-icon"
                                    (click)="openLoveItPopup(product)" loading="lazy" /> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>